<template>
  <div class="cadmin">
    <div class="row mt-4 nav-items-container align-items-center justify-content-center">
        <router-link class="nav-item border rounded text-center col-3 mx-3"
                  :to="`/cadmin/doctors`">
            <div>
                <h4 class="mb-0 p-5">{{$t('doctors')}}</h4>
            </div>
        </router-link>
        <router-link class="nav-item border rounded text-center col-3 mx-3"
                  :to="`/cadmin/services`">
            <div>
                <h4 class="mb-0 p-5">{{$t('clinic_services')}}</h4>
            </div>
        </router-link>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Fetch from '@/mixins/Fetch'
export default {
  components: {
  },
  mixins: [Fetch],
  data () {
    return {
      clinic: null,
      doctors: [],
      loadingDoctors: false
    }
  },
  computed: {
    ...mapGetters({
      type: 'auth/type',
      authLocale: 'auth/locale',
      chats: 'chat/chatsWithDoctor',
      headHeight: 'head/height',
      schedules: 'schedule/schedulesAscNotCancelled',
      staticUrl: 'app/staticUrl',
      isOnline: 'status/isOnline',
      doctorById: 'doctor/byId',
      notifications: 'notification/notifications'
    })
  },
  mounted () {
    console.log('I am here')
  },
  methods: {
    ...mapActions({ seen: 'notification/seen' }),
    ...mapMutations({
      setAlert: 'alert/setAlert',
      setChats: 'chat/set',
      setSchedule: 'schedule/set',
      resetSchedule: 'schedule/reset',
      setUser: 'user/set',
      setDoctor: 'doctor/set',
      setNotifications: 'notification/setNotifications'
    })
  }
}
</script>
<style lang="scss">
    .cadmin {
        height:100%;
    }
    .nav-items-container {
        height:50%;
    }
    .nav-item {
        color:#343a40db;
        cursor:pointer;
    }
    .nav-item:hover{
        color:#2f76bc;
        text-decoration:none;
    }
</style>
<i18n>
{
  "ka": {
      "doctors": "ექიმები",
      "clinic_services": "კლინიკის სერვისები"
  }
}
</i18n>
